import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {EditorModelService} from "@irb/irb-editors/editor-model/editor-model.service";
import {IrbSettingsEvents} from "@irb/irb-settings/irb-settings.events";
import {AppService} from "@irb/app.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {
  DropdownSearchMultipleComponent
} from "@irb-common/components/dropdown-search-multiple/dropdown-search-multiple.component";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {Subscription} from "rxjs";
import {IEvent, IrbAppEvents} from "@irb-common/events";
import {
  TlhRebalanceSettingsGridLayoutService
} from "@irb/irb-editors/editor-harvest-tax-loss-rebalance/tlh-rebalance-settings/tlh-rebalance-settings.grid-layout.service";
import {CalltoactionService} from "@irb-common/components/calltoaction/calltoaction.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {faDownload} from "@fortawesome/free-solid-svg-icons";


@Component({ standalone: false,
  selector: 'irb-tlh-rebalance-settings',
  templateUrl: './tlh-rebalance-settings.component.html',
  styleUrls: ['./tlh-rebalance-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class TlhRebalanceSettingsComponent implements OnInit, OnDestroy {

  @ViewChild('harvestedSecuritiesSameWayAsDropdown') harvestedSecuritiesSameWayAsDropdown: DropdownFilterComponent;
  @ViewChild('harvestedSecuritiesDropdown') harvestedSecuritiesDropdown: DropdownSearchMultipleComponent;
  @ViewChild("primarySecuritiesDropdownDropdown") primarySecuritiesDropdownDropdown: any;
  @ViewChild("secondarySecuritiesDropdownDropdown") secondarySecuritiesDropdownDropdown: any;

  _data: any;
  originalData: any;

  @Input() analysisType = "";

  @Input()
  get data(): any {
    return this._data;
  }

  set data(d: any) {
    this._data = d;
    this.originalData = this.util.clone(d);
  }

  _isReadOnly: boolean = false;

  @Input()
  get isReadOnly(): any {
    return this._isReadOnly;
  }

  set isReadOnly(d: any) {
    this._isReadOnly = d;
  }

  @Output() change = new EventEmitter<boolean>();
  @Output() closeAndNavigate = new EventEmitter<string>();

  globalSettings: any;
  isApplyGlobalTLH = true;
  private harvestTaxLossTypeDropdown: any = [];
  isReadOnlyClear: boolean = true;
  private securitiesTargets: Array<IDropdownItem> = [];
  securityTargetData: any;
  addNewSecurityItem: any = {
    button: 'Add new security',
    type: 'security',
    fromComp: 'ComTlhRebalanceSettingsComponent'
  };
  eventSubscription: Subscription;
  selectedSecToAdd: Array<any>;
  percentAmount: any = 0;
  dollarAmount: any = 0;
  selectedPrimarySecurity: IDropdownItem = {} as IDropdownItem;
  selectedSecondarySecurity: IDropdownItem = {} as IDropdownItem;
  securitiesTargetsGrid: any = [];
  securitiesWithOutCash: any = [];
  isUiTest = false;
  grid: any;
  gridOptions: any;
  frameworkComponents: any;
  regExpPercent: RegExp = /^(?:\d*\.\d{1,2}|\d+)$/;
  cashSecurity: any;
  isGlobalTlhLotLevel: boolean;
  isGlobalTlhPositionLevel: boolean;
  rowCount: any = 0;
  protected readonly faDownload = faDownload;

  constructor(private editorModelService: EditorModelService, private as: AppService,
              private ies: IrbEditorsService,
              private tlhrsGridLayoutService: TlhRebalanceSettingsGridLayoutService,
              private util: UtilityService,
              private ctas: CalltoactionService) {
    this.globalSettings = this.editorModelService.getGlobalSettings();
    if (this.globalSettings) {
      this.isApplyGlobalTLH = this.globalSettings.isTlhLotLevel || this.globalSettings.isTlhPositionLevel;
      this.isGlobalTlhLotLevel = this.globalSettings.isTlhLotLevel;
      this.isGlobalTlhPositionLevel = this.globalSettings.isTlhPositionLevel;
    } else
      this.globalSettings = {};
  }

  ngOnInit(): void {
    if (this.data && this.data.harvestTaxLossDto)
      this.isApplyGlobalTLH = this.data.harvestTaxLossDto.isApplyGlobalTLH;

    if (this.isApplyGlobalTLH) {
      if (this.data && this.data.harvestTaxLossDto && this.data.analysisId) {
        this.isGlobalTlhLotLevel = this.data.harvestTaxLossDto.isLotLevel ? true : false;
        this.isGlobalTlhPositionLevel = this.data.harvestTaxLossDto.isLotLevel === false ? true : false;
      }
    }

    this.ies.getTaxLossHarvestDetail().subscribe((data: any) => {
      data.responseData.items.forEach((item: any) => {
        this.harvestTaxLossTypeDropdown.push({
          name: item.name,
          value: item.id
        });
      });
    });

    this.frameworkComponents = this.tlhrsGridLayoutService.getFrameworkComponents() || {};
    this.gridOptions = {
      columnDefs: this.tlhrsGridLayoutService.getColumnDefs(this),
      floatingFilter: false,
      overlayNoRowsTemplate:
        "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No Securities assigned</span>",
      context: {componentParent: this},
      suppressCellSelection: this.isReadOnly,
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
      excelStyles: [
        {
          id: 'excelUSD',
          numberFormat: {
            format: '$#,##0.00',
          },
        },
        {
          id: 'percentageCell',
          numberFormat: {
            format: '#0.00%',
          },
        },
        {
          id: 'excelString',
          dataType: 'String'
        }
      ]
    };

    this.ies.getSecuritiesSearchDropDown("$CASH").subscribe((cashObj: any) => {
      this.cashSecurity = cashObj.items[0];//{value: 5103470, name: "$CASH"}
      this.cashSecurity.name = "$CASH (Leave in Cash)"

      this.ies.getTaxLossSecuritiesDropDown().subscribe((data: any) => {
        this.loadSecuritiesDropdown(data);
      });

      this.checkGridDataForWsa();
    });


    this.eventSubscription = this.as.getEvents().subscribe((s) => {
      this.processEvent(s);
    });
  }

  checkGridDataForWsa() {
    if (this.data && this.data.harvestTaxLossDto && this.data.harvestTaxLossDto.htlSecsdtoList) {
      this.data.harvestTaxLossDto.htlSecsdtoList.forEach((sec: any) => {
        if (!sec.primarySecSymb && sec.replaceSecSymb) {
          sec.primarySecSymb = sec.replaceSecSymb;
          sec.primarySecId = sec.replaceSecId;
          sec.primarySecType = sec.replaceSecType;
          sec.secondarySecSymb = null;
          sec.secondarySecId = null;
          sec.secondarySecType = null;
          if (this.cashSecurity.value === sec.primarySecId) {
            sec.secondarySecSymb = null;
            sec.secondarySecId = null;
            sec.secondarySecType = null;
          }
        }
        if (!sec.primarySecId) {
          sec.secondarySecSymb = null;
          sec.secondarySecId = null;
          sec.secondarySecType = null;
        }
      })
    }
  }

  setSameTLHOptions(searchStr: any) {
    this.harvestedSecuritiesSameWayAsDropdown.set(DropdownFilterComponent.getFilteredList(searchStr,this.harvestTaxLossTypeDropdown));
  }
  onHtlChange(event: any) {
    let htlCloneData = {cloneId: event.value};
    this.isReadOnlyClear = false;
    this.ies.getTaxLossHarvestClone(htlCloneData).subscribe((cloneData: any) => {
      if (cloneData.isLotLevel === true) {
        this.data.harvestTaxLossDto.isLotLevel = true;
      } else {
        this.data.harvestTaxLossDto.isLotLevel = false;
      }
      cloneData.htlSecsdtoList.forEach((cloneSec: any) => {
        if (!cloneSec.primarySecSymb) {
          cloneSec.primarySecSymb = cloneSec.replaceSecSymb;
          cloneSec.primarySecId = cloneSec.replaceSecId;
          cloneSec.primarySecType = cloneSec.replaceSecType
          cloneSec.secondarySecSymb = "";
          cloneSec.secondarySecId = null;
          cloneSec.secondarySecType = "";
          if (!cloneSec.primarySecId || this.cashSecurity.value === cloneSec.primarySecId) {
            cloneSec.secondarySecSymb = null;
            cloneSec.secondarySecId = null;
            cloneSec.secondarySecType = null;
          }
        }
      });

      this.data.harvestTaxLossDto.htlSecsdtoList = cloneData.htlSecsdtoList;
      this.loadGrid();
      this.emitChange();
    });
  }

  filterSecurities(searchString: string): void {

    this.harvestedSecuritiesDropdown.set(
      DropdownFilterComponent.getFilteredList(searchString, this.securitiesWithOutCash)
        .map(security => ({
          name: security.name,
          value: security.value
        }))
    );
  }

  loadSecuritiesDropdown(data: any) {
    this.securityTargetData = data.items;
    for (let i = 0; i < data.items.length; i++) {
      if (data.items[i].securityType !== 'OPTION')
        this.securitiesTargets.push({name: data.items[i].securitySymbol, value: data.items[i].securityId});
      // this.securitiesTargetsGrid.push({name: data.items[i].securitySymbol, value: data.items[i].securityId});
    }
    this.securitiesWithOutCash = this.securitiesTargets.filter(security => security.name !== '$CASH');
    this.securitiesWithOutCash = this.sortArrayList(this.securitiesWithOutCash );
    this.loadGrid();
  }
    sortArrayList(arrayList: any) {
        return arrayList.sort((a:any, b:any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }

  captureAddSecurity(event: Array<IDropdownItem>) {
    let harvestSecType = "";
    this.selectedSecToAdd = [];
    if (event) {
      let newSec: any;
      event.forEach((item: IDropdownItem) => {
        newSec = {
          dollarAmount: this.globalSettings.tlhMinDollarAmnt || 0,
          harvestSecId: item.value,
          harvestSecSymb: item.name,
          harvestSecType: harvestSecType,
          isUIdeleted: false,
          isNew: true,
          percentageAmount: this.globalSettings.tlhMinPerc || 0,
          primarySecId: null,
          primarySecSymb: null,
          primarySecType: null,
          secondarySecId: null,
          secondarySecSymb: null,
          secondarySecType: null,
          isSwapExchange: false
        };
        this.securityTargetData.forEach((element: any) => {
          if (element.securitySymbol === item.name) {
            newSec.harvestSecType = element.securityType;
            newSec.primarySecId = element.primarySecId || null;
            newSec.primarySecSymb = element.primarySecSymb || null;
            newSec.primarySecType = element.primarySecType || null;
            newSec.secondarySecId = element.secondarySecId;
            newSec.secondarySecSymb = element.secondarySecSymb;
            newSec.secondarySecType = element.secondarySecType;

            if (!newSec.primarySecId || newSec.primarySecId === this.cashSecurity.value) {
              newSec.secondarySecId = null;
              newSec.secondarySecSymb = null;
              newSec.secondarySecType = null;
            }
          }
        });

        this.selectedSecToAdd.push(newSec);
      });
    }
  }

  showAddMultipleSecuritiesDialog() {
    let dataInputForMultipleSelection: any = [];//{harvestSecId: 5335254, securitySymbol: "$BKX", securityType: "OTHER"}
    this.grid.api.forEachNode(function (node: any) {
      if (!node.data.isUIdeleted)
        dataInputForMultipleSelection.push(node.data);
    });
    const params = {
      type: 'rebalanceTLH',
      field: "harvestSecId",
      data: dataInputForMultipleSelection,
      noDollarcash: true
    };
    this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
  }

  loadGrid() {
    if (this.data.harvestTaxLossDto && this.data.harvestTaxLossDto.htlSecsdtoList && this.data.harvestTaxLossDto.htlSecsdtoList.length) {
      this.data.harvestTaxLossDto.htlSecsdtoList.forEach((row: any) => {
        if (this.cashSecurity.value === row.primarySecId)
          row.primarySecSymb = '$CASH (Leave in Cash)';
        if (this.cashSecurity.value === row.secondarySecId)
          row.secondarySecSymb = '$CASH (Leave in Cash)';

        if (!row.primarySecId || this.cashSecurity.value === row.primarySecId) {
          row.secondarySecSymb = null;
          row.secondarySecId = null;
          row.secondarySecType = null;
        }
      });
      this.grid?.api.setGridOption('rowData', this.data.harvestTaxLossDto.htlSecsdtoList);
    } else {
      this.grid?.api.setGridOption('rowData', []);
    }
    this.rowCount = this.getRowCount();
  }

  onApplyGlobalchange(event: any) {
    this.data.harvestTaxLossDto.isApplyGlobalTLH = event.checked;
    this.change.emit(this.data);
  }

  openRebalanceGlobalSettings() {
    this.as.fireEvent(IrbSettingsEvents.SHOW, {defaultTabIndex: 4});
  }

  emitChange() {
    this.change.emit(this.data);
  }

  onClearTaxLossToClone(){
    this.harvestedSecuritiesSameWayAsDropdown?.setValue(null);
    this.data.harvestTaxLossDto.isLotLevel = true;
    this.data.harvestTaxLossDto.htlSecsdtoList = [];
    this.isReadOnlyClear = true;
    this.loadGrid();
    this.emitChange();
  }

  openNewItemSecurityFlow(dataParam: any, forGrid: boolean) {
    if (!forGrid) {
      dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
    }
    this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
  }

  openNewItemSecurityFlowForReplace(dataParam: any, primary: boolean) {
    let passingDataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
    passingDataParam.primary = primary;
    passingDataParam.fromComp = 'TLHRebalanceReplaceWith';
    this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, passingDataParam);
  }


  processEvent(event: IEvent) {
    switch (event.type) {
      case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
        if (event.data) {
          if (event.data.type === 'security' && (event.data.fromComp === 'ComTlhRebalanceSettingsComponent'
              || event.data.fromComp === 'TLHRebalanceGridLayoutService' || event.data.fromComp === 'TLHRebalanceReplaceWith')) {
            this.resetSecuritySearch(event.data);
          }
        }
        break;
      case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
        if (event.data && event.data.type === 'rebalanceTLH') {
          this.updateWithMultipleSecurity(event.data);
        }
        break;
    }
  }

  addSecurity() {
    let dupelems: any = [];
    this.selectedSecToAdd.forEach((item: any) => {
      if (item && !this.checkDuplicateSecurity(item)) {
        if (this.data.harvestTaxLossDto.htlSecsdtoList) {
          this.data.harvestTaxLossDto.htlSecsdtoList.push(item);
        }
      } else {
        this.data.harvestTaxLossDto.htlSecsdtoList.forEach((newsec: any) => {
          dupelems.push(newsec);
        });
      }
    });
    if (dupelems.length > 0) {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: "warn",
        summary: "",
        detail: "Security(ies) cannot be listed twice.",
      });
    }
    if (this.data.harvestTaxLossDto.htlSecsdtoList.length > 0) {
      this.loadGrid();
      this.emitChange();
      this.harvestedSecuritiesDropdown.clear();
    }
  }

  checkDuplicateSecurity(item: any) {
    if (this.data.harvestTaxLossDto.htlSecsdtoList) {
      let selectedSecid = item.harvestSecId;
      return this.data.harvestTaxLossDto.htlSecsdtoList.some((elem: any) => {
        return elem.harvestSecId === selectedSecid;
      });
    } else {
      return false;
    }
  }

  updateWithMultipleSecurity(event: any) {
    let addedSecurities = event.selectedSecurities;
    let dupElms: any = [];

    addedSecurities.forEach((security: any) => {
      let secToBeAdded: any = {
        dollarAmount: this.globalSettings.tlhMinDollarAmnt || 0,
        harvestSecId: security.securityId,
        harvestSecSymb: security.securitySymbol,
        harvestSecType: security.securityType,
        isUIdeleted: false,
        isNew: true,
        percentageAmount: this.globalSettings.tlhMinPerc || 0,
        primarySecId: security.primarySecId,
        primarySecSymb: security.primarySecSymb,
        primarySecType: security.primarySecType,
        secondarySecId: security.secondarySecId,
        secondarySecSymb: security.secondarySecSymb,
        secondarySecType: security.secondarySecType
      };
      if (this.data.harvestTaxLossDto.htlSecsdtoList) {
        if (this.data.harvestTaxLossDto.htlSecsdtoList.some((existSec: any) => {
          return existSec.harvestSecId === security.securityId;
        })) {
          dupElms.push(security)
        } else {
          this.data.harvestTaxLossDto.htlSecsdtoList.push(secToBeAdded);
        }
      }
    });

    this.loadGrid();
    this.emitChange();
  }

  resetSecuritySearch(dataParam: any) {
    if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {

      this.securitiesTargets = this.securitiesTargets.concat(dataParam.newItemsForDD);
      this.securitiesWithOutCash = this.securitiesWithOutCash.concat(dataParam.newItemsForDD);
      if (dataParam.securities && dataParam.securities.responseData)
        this.securityTargetData = this.securityTargetData.concat(dataParam.securities.responseData);

      if (dataParam.fromComp === 'ComTlhRebalanceSettingsComponent') {
        this.harvestedSecuritiesDropdown.setValue(dataParam.newItemsForDD);
        this.captureAddSecurity(dataParam.newItemsForDD);
      }
      if (dataParam.fromComp === 'TLHRebalanceGridLayoutService') {
        const rowIndex: number = dataParam.rowIndex;
        if (rowIndex !== null || typeof rowIndex !== "undefined") {
          this.grid.api.forEachNode((node: any) => {
            if (node.rowIndex === rowIndex) {
              if (dataParam.primary) {
                node.data.primarySecId = dataParam.newItemsForDD[0].value;
                node.data.primarySecSymb = dataParam.newItemsForDD[0].name;
                this.securityTargetData.forEach((element: any) => {
                  if (element.securitySymbol === dataParam.newItemsForDD[0].name) {
                    node.data.primarySecType = element.securityType;
                  }
                });
              } else {
                node.data.secondarySecId = dataParam.newItemsForDD[0].value;
                node.data.secondarySecSymb = dataParam.newItemsForDD[0].name;
                this.securityTargetData.forEach((element: any) => {
                  if (element.securitySymbol === dataParam.newItemsForDD[0].name) {
                    node.data.secondarySecType = element.securityType;
                  }
                });
              }
            }
          });
          const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
          this.grid.api.redrawRows({rowNodes: [n]});
          this.emitChange();
        }
      }

      if (dataParam.fromComp === 'TLHRebalanceReplaceWith') {
        if (dataParam.primary)
          this.primarySecuritiesDropdownDropdown.setValue(dataParam.newItemsForDD[0]);
        else
          this.secondarySecuritiesDropdownDropdown.setValue(dataParam.newItemsForDD[0]);
      }

      this.ies.getTaxLossSecuritiesDropDown().subscribe((data: any) => {
        this.securitiesTargets = [];
        this.loadSecuritiesDropdown(data);
      });
    }
  }

  onPercentChange() {  }
  onPercentApply() {
    if (this.validatePercentage() && this.data.harvestTaxLossDto && this.data.harvestTaxLossDto.htlSecsdtoList && this.data.harvestTaxLossDto.htlSecsdtoList.length) {
      this.data.harvestTaxLossDto.htlSecsdtoList.forEach((element: any) => {
        element.percentageAmount = this.percentAmount;
      })
      this.loadGrid();
      this.emitChange();
    }
  }

  onDollarChange() {}
  onDollarApply() {
    if (this.validateDollar() && this.data.harvestTaxLossDto && this.data.harvestTaxLossDto.htlSecsdtoList && this.data.harvestTaxLossDto.htlSecsdtoList.length) {
      this.data.harvestTaxLossDto.htlSecsdtoList.forEach((element: any) => {
        element.dollarAmount = this.dollarAmount;
      });
      this.loadGrid();
      this.emitChange();
    }
  }

  validatePercentage() {
    if (!this.regExpPercent.test(this.percentAmount)) {
      return false;
    }
    if (parseFloat(this.percentAmount) > 100.0) {
      return false;
    }
    return true;
  }

  validateDollar() {
    if (!this.regExpPercent.test(this.dollarAmount)) {
      return false;
    } else {
      return true;
    }
  }

  onClearSelection(type: string) {
    if (type === 'primary') {
      this.onPrimarySecurityChanged(null);
    }
    if (type === 'secondary') {
      this.onSecondarySecurityChanged(null);
    }
  }

  getPrimarySecuritiesDropdown(searchString: any) {
    const d: any = DropdownFilterComponent.getFilteredList(searchString, this.securitiesWithOutCash);
    if (d.length !== 0 || searchString === '') {
      d.unshift({name: '$CASH (Leave in Cash)', value: this.cashSecurity.value});
    }
    d.unshift({name: 'N/A (None)', value: this.cashSecurity.value});
    this.primarySecuritiesDropdownDropdown.set(d);
  }

  onPrimarySecurityChanged(selections: IDropdownItem) {
    this.selectedPrimarySecurity = selections;
  }

  onSecondarySecurityChanged(selections: IDropdownItem) {
    this.selectedSecondarySecurity = selections;
  }

  getSecondarySecuritiesDropdown(searchString: any) {
    const d: any = DropdownFilterComponent.getFilteredList(searchString, this.securitiesWithOutCash);
    if (d.length !== 0 || searchString === '') {
      d.unshift({name: '$CASH (Leave in Cash)', value: this.cashSecurity.value});
    }
    d.unshift({name: 'N/A (None)', value: this.cashSecurity.value});
    this.secondarySecuritiesDropdownDropdown.set(d);
  }

  onPrimarySecurityApply() {
    if (!this.data?.harvestTaxLossDto?.htlSecsdtoList?.length) {
      return;
    }

    let selectedPrimary = this.selectedPrimarySecurity || {} as IDropdownItem;
    if (this.selectedPrimarySecurity?.name && this.selectedPrimarySecurity?.name.toLowerCase() === 'n/a (none)') {
      selectedPrimary = {} as IDropdownItem;
    }
    const cashSecurity = this.cashSecurity;

    // Create a map for faster lookup of security types
    const securityTypeMap = new Map(
      this.securityTargetData.map((el: any) => [el.securityId, el.securityType])
    );

    this.data.harvestTaxLossDto.htlSecsdtoList.forEach((element: any) => {
      if (element.harvestSecId === selectedPrimary.value) {
        return;
      }

      element.primarySecId = selectedPrimary.value;
      element.primarySecSymb = selectedPrimary.name;
      element.primarySecType = securityTypeMap.get(selectedPrimary.value) || null;

      if (selectedPrimary.name?.includes('$CASH') || element.secondarySecId === selectedPrimary.value) {
        element.secondarySecId = null;
        element.secondarySecSymb = null;
        element.secondarySecType = null;
      }
    });

    this.loadGrid();
    this.emitChange();
  }

  onSecondarySecurityApply() {
    if (!this.data?.harvestTaxLossDto?.htlSecsdtoList?.length) {
      return;
    }

    let selectedSecondary = this.selectedSecondarySecurity || {} as IDropdownItem;
    if (this.selectedSecondarySecurity?.name && this.selectedSecondarySecurity?.name.toLowerCase() === 'n/a (none)') {
      selectedSecondary = {} as IDropdownItem;
    }
    const securityTypeMap = new Map(
      this.securityTargetData.map((el: any) => [el.securityId, el.securityType])
    );

    this.data.harvestTaxLossDto.htlSecsdtoList.forEach((element: any) => {
      if (
        element.primarySecSymb &&
        !element.primarySecSymb.includes('$CASH') &&
        element.primarySecId !== selectedSecondary.value &&
        element.harvestSecId !== selectedSecondary.value
      ) {
        element.secondarySecId = selectedSecondary.value;
        element.secondarySecSymb = selectedSecondary.name;
        element.secondarySecType = securityTypeMap.get(selectedSecondary.value) || null;
      }
    });

    this.loadGrid();
    this.emitChange();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.loadGrid();
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node: any) {
    return !node.data.isUIdeleted;
  }

  deleteAll() {
    for (let i = 0; i < this.data.harvestTaxLossDto.htlSecsdtoList.length; i++) {
      this.data.harvestTaxLossDto.htlSecsdtoList[i].isUIdeleted = true;
    }
    this.data.harvestTaxLossDto.htlSecsdtoList = this.data.harvestTaxLossDto.htlSecsdtoList.filter((x: any) => !(x.isNew && x.isUIdeleted));
    this.grid.api.deselectAll();
    this.grid.api.hideOverlay();
    this.loadGrid();
    this.emitChange();
  }

  delete(cc: any) {
    for (let i = 0; i < this.data.harvestTaxLossDto.htlSecsdtoList.length; i++) {
      if (this.data.harvestTaxLossDto.htlSecsdtoList[i].harvestSecId === cc.harvestSecId) {
        this.data.harvestTaxLossDto.htlSecsdtoList[i].isUIdeleted = true;
        break;
      }
    }
    this.data.harvestTaxLossDto.htlSecsdtoList = this.data.harvestTaxLossDto.htlSecsdtoList.filter((x: any) => !(x.isNew && x.isUIdeleted));
    this.loadGrid();
    this.emitChange();
  }

  cancelDelete() {
    this.ctas.remove();
  }

  getRowCount() {
    return (this.data.harvestTaxLossDto && this.data.harvestTaxLossDto.htlSecsdtoList) ? this.data.harvestTaxLossDto.htlSecsdtoList.filter((x: any) => x.isUIdeleted === false).length : 0;
  }

  goToSecurities() {
    this.closeAndNavigate.emit("/models/security-master");
  }

  exportToExcel() {
    const excelExportParams: any = {
      skipColumnGroupHeaders: true,
      sheetName: 'TLH_Securities_Settings',
      fileName: 'TLH_Securities_Settings_' + this.data.analysisName,
      columnKeys: ['harvestSecSymb', 'percentageAmount', 'dollarAmount', 'primarySecSymb', 'secondarySecSymb', 'isSwapExchange'],
      processHeaderCallback: (params: any)=> {
        if (params.column.getColId() === 'harvestSecSymb') {
          return 'Symbol/CUSIP';
        } else if (params.column.getColId() === 'percentageAmount') {
          return 'Min Loss %';
        } else if (params.column.getColId() === 'dollarAmount') {
          return 'Min Loss $';
        } else if (params.column.getColId() === 'primarySecSymb') {
          return 'Primary Replacement';
        } else if (params.column.getColId() === 'secondarySecSymb') {
          return 'Secondary Replacement';
        } else if (params.column.getColId() === 'isSwapExchange') {
          return 'Swap/Exchange';
        } else {
          return params.api.getDisplayNameForColumn(params.column, null);
        }
      },
      processCellCallback: (params: any) => {
        if (params.column.colId === 'percentageAmount') {
          if (params.value)
            return params.value/100;
          else
            return params.value;
        }
        return params.value;
      }
    };
    this.grid?.api.exportDataAsExcel(excelExportParams);
  }

  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

}
